import modalUploadList from './view/modalUploadList.html'
import modalListTemplate from './view/modalList.html'
import utils from 'utils'
class reimburseEditCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, $stateParams, formvalidateApi, sweetalert) {
        const { expenseId } = $stateParams
        // 初始化表单数据
        $scope.selectedFieldList = []// 选中的报销票据
        $scope.removedInvoiceList = []// 移除但是未保存的票据
        $scope.showtotal = 0 // 只展示发票总数
        function resetData() {
            $scope.reimburseFrom = {
                userName: JSON.parse(localStorage.user_info).user.realName,
                departmentName: '',
                departmentId: '',
                // projectName: '',
                projectId: '',
                remark: '',
                type: '',
                amount: 0.00,
                number: 0,
                // deductionAmt: 0,
                // deductionDate: "string",
                // turnOutAmt: 0,
                orgId: $scope.userInfo.org.orgId,
                otherFileList: [],
                ivatExpenseBillRList: [],
                ivatExpenseBillRMap: {},
            }
        }
        resetData()

        httpRequest.get_getProjectlistOfCurrentOrg().then(res => {
            $scope.projectList = res.data.value
            let userInfo=localStorage.user_info&&JSON.parse(localStorage.user_info)
            $scope.currentOrgId=userInfo.user.currentOrgId
            $scope.orgOwnership=userInfo.user.orgOwnership
            // 编辑功能
            if (expenseId !== undefined) {
                httpRequest.get_getExpenseDetailById({ expenseId }).then((res) => {
                    if (res.data.success) {
                        const oldAmount = res.data.value.amount
                        $scope.reimburseFrom = res.data.value
                        httpRequest.get_getIvatBxPzEnable().then((res) => {
                            $scope.reimburseFrom.amount = oldAmount // 第一次进入编辑不改变金额
                            $scope.typeList = res.data.value
                            $scope.typeChange()
                        })
                    }
                })
            } else {
                httpRequest.get_getIvatBxPzEnable().then((res) => {
                    $scope.typeList = res.data.value
                    $scope.reimburseFrom.type = $scope.typeList[0].confId
                    if($scope.currentOrgId==$scope.orgOwnership){
                        $scope.reimburseFrom.departmentId=userInfo.user.departmentId
                        $scope.reimburseFrom.departmentName=userInfo.user.departmentName
                    }
                    $scope.typeChange()
                })
            }
        })
        $scope.$watch('reimburseFrom.ivatExpenseBillRList', (newValue, oldValue) => {
            $scope.reimburseFrom.number = 0
            $scope.showtotal = 0.00
            if (newValue && newValue.length > 0) {
                newValue.forEach((item) => {
                    $scope.showtotal += item.totalAmt ? +item.totalAmt : 0.00
                })
                $scope.showtotal = $scope.showtotal.toFixed(2)
                $scope.reimburseFrom.amount = $scope.showtotal
                $scope.reimburseFrom.number = newValue.length
            }
        }, true)

        $scope.uploadTypes = [{
            enumCode: '1',
            enumName: '扫描发票',
        }, {
            enumCode: '2',
            enumName: '本地文件',
        }, {
            enumCode: '3',
            enumName: '已有票据',
        }]

        httpRequest.get_dictByTypeArr(['ivat_inv_type']).then((res) => {
            $scope.dictionary = res.data.value
        })

        httpRequest.get_getDeparmentOfOrg().then((res) => {
            $scope.departmentList = res.data.value
        })

        $scope.typeSelectedList = []
        $scope.typeChange = function (manuChageFlag) {
            $scope.selectedFieldList = []
            $scope.showTotal = $scope.selectedFieldList.length > 0
            let bigType
            $scope.typeList.forEach((x) => {
                if (x.confId === $scope.reimburseFrom.type) {
                    bigType = x
                }
            })
            $scope.typeSelectedList = []
            if (manuChageFlag) {
                $scope.reimburseFrom.ivatExpenseBillRList = $scope.reimburseFrom.ivatExpenseBillRList.filter((x) => x.confId == bigType.confId)// 筛选出与当前大类的票据
            }
            if (bigType) {
                bigType.mxList.forEach((m) => {
                    m.selected = false
                    if (expenseId !== undefined) {
                        const temp = $scope.reimburseFrom.ivatExpenseBillRList.some((x) => x.confId == m.confId)
                        if (temp) {
                            m.selected = true
                            m.ivatExpenseBillRList = []
                            $scope.reimburseFrom.ivatExpenseBillRList.forEach((v) => {
                                if (v.confId == m.confId) {
                                    m.ivatExpenseBillRList.push(v)
                                }
                            })
                            $scope.selectedFieldList.push(m)
                        }
                    }
                    $scope.typeSelectedList.push(m)
                })
            }
            $scope.showTotal = $scope.selectedFieldList.length > 0
            if (expenseId == undefined) {
                $scope.selectedFieldList = []
            }
        }

        $scope.fieldCodeChange = function (filed) {
            if (filed.selected) {
                const isExist = $scope.selectedFieldList.some((x) => x.confId === filed.confId)
                if (filed.selected && !isExist) {
                    // filed.ivatExpenseBillRList = []
                    $scope.selectedFieldList.push(filed)
                }
            } else {
                $scope.selectedFieldList = $scope.selectedFieldList.filter((item) => {
                    if (item.confId == filed.confId && item.ivatExpenseBillRList) {
                        item.ivatExpenseBillRList.length = 0
                    }
                    return item.confId !== filed.confId
                })
                $scope.reimburseFrom.ivatExpenseBillRList = $scope.reimburseFrom.ivatExpenseBillRList.filter((x) => x.confId !== filed.confId)
            }
            $scope.showTotal = $scope.selectedFieldList.length > 0
        }
        
        function matchDepartmentName(id) {
            if(!id) return ''
            let name
            $scope.departmentList.forEach((item)=>{
                if(item.departmentId===id) {
                    name = item.departmentName
                    return
                }
            })
            return name
        }

        $scope.saveReimburseInfo = function () {
            $scope.reimburseFrom.departmentName = matchDepartmentName($scope.reimburseFrom.departmentId)
            const ret = formvalidateApi.run()
            if(!$scope.reimburseFrom.departmentId) {
                logger.logError('部门为必填项')
                return
            }
            if (!$scope.reimburseFrom.remark) {
                logger.logError('报销事由为必填项')
                return
            }
            if (ret) {
                const haveList = ($scope.reimburseFrom.ivatExpenseBillRList && $scope.reimburseFrom.ivatExpenseBillRList.length > 0) || ($scope.reimburseFrom.otherFileList && $scope.reimburseFrom.otherFileList.length > 0)
                if (haveList) {
                    if (expenseId !== undefined) {
                        httpRequest.post_modifyExpenseItem($scope.reimburseFrom, '修改成功').then((res) => {
                            $state.go('input.reimburseManage.reimbursement.list')
                        })
                    } else {
                        httpRequest.post_addExpenseItem($scope.reimburseFrom, '保存成功').then((res) => {
                            $state.go('input.reimburseManage.reimbursement.list')
                        })
                    }
                } else {
                    return logger.logError('请在“报销票据”或“其他单据”上传相关报销附件内容！')
                }
            }
        }
        $scope.saveAndSubmit = function () {
            $scope.reimburseFrom.departmentName = matchDepartmentName($scope.reimburseFrom.departmentId)
            const ret = formvalidateApi.run()
            if(!$scope.reimburseFrom.departmentId) {
                logger.logError('部门为必填项')
                return
            }
            if (!$scope.reimburseFrom.remark) {
                logger.logError('报销事由为必填项')
                return
            }
            if (ret) {
                const haveList = ($scope.reimburseFrom.ivatExpenseBillRList && $scope.reimburseFrom.ivatExpenseBillRList.length > 0) || ($scope.reimburseFrom.otherFileList && $scope.reimburseFrom.otherFileList.length > 0)
                if (haveList) {
                    utils.loading('正在提交')
                    if (expenseId !== undefined) {
                        httpRequest.post_modifyExpenseItem($scope.reimburseFrom).then((res) => {
                            $scope.editDoSubmit([expenseId])
                        }).catch(err=>{
                            utils.loaded()
                        })
                    } else {
                        httpRequest.post_addExpenseItem($scope.reimburseFrom).then((res) => {
                            $scope.editDoSubmit([res.data.value])
                        }).catch(err=>{
                            utils.loaded()
                        })
                    }
                } else {
                    return logger.logError('请在“报销票据”或“其他单据”上传相关报销附件内容！')
                }
            }
        }
        $scope.editDoSubmit = function (reimArr) {
            httpRequest.post_batchSubmitExpenses(reimArr).then((res) => {
                if (res.data.success) {
                    logger.logSuccess('票据提交成功')
                }
                $state.go('input.reimburseManage.reimbursement.list')
            }).finally(() => {
                utils.loaded()
            })
        }
        $scope.cancle = function () {
            $state.go('input.reimburseManage.reimbursement.list')
        }
        $scope.uploadInvoice = function (uploadType, confId) {
            const uploadListModal = $uibModal.open({
                template: modalUploadList,
                controller: 'modalUploadListCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-detail',
                resolve: {
                    items1() {
                        const data = {
                            removedInvoiceList: $scope.removedInvoiceList,
                            uploadType,
                            selectedInvoiceList: $scope.reimburseFrom.ivatExpenseBillRList,
                            dataSource:'5'
                        }
                        return data
                    },
                },
            })
            uploadListModal.result.then((data) => {
                if (data) {
                    let repeateFlag = false
                    $scope.reimburseFrom.ivatExpenseBillRList.forEach((r) => {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].invoiceId == r.invoiceId) {
                                repeateFlag = true
                                logger.logError('存在已添加票据，请重新选择')
                                break
                            }
                        }
                    })
                    if (!repeateFlag) { // 不存在重复 继续执行
                        $scope.selectedFieldList.forEach((file) => {
                            if (file.confId == confId) {
                                if (file.ivatExpenseBillRList == undefined) {
                                    file.ivatExpenseBillRList = []
                                }
                                if (file.ivatExpenseBillRList.length > 0) {
                                    data.forEach((item) => {
                                        let isExist = false
                                        for (let i = 0; i < file.ivatExpenseBillRList.length; i++) {
                                            if (file.ivatExpenseBillRList[i].invoiceId == item.invoiceId) {
                                                isExist = true
                                            }
                                        }
                                        if (!isExist) {
                                            const obj = item
                                            obj.confId = confId
                                            obj.invoiceType = item.invoiceType
                                            obj.totalAmt = item.adValoremTotal
                                            file.ivatExpenseBillRList.push(obj)
                                            $scope.reimburseFrom.ivatExpenseBillRList.push(obj)
                                        }
                                    })
                                } else {
                                    data.forEach((item) => {
                                        const obj = item
                                        obj.confId = confId
                                        obj.invoiceType = item.invoiceType
                                        obj.totalAmt = item.adValoremTotal
                                        file.ivatExpenseBillRList.push(obj)
                                        $scope.reimburseFrom.ivatExpenseBillRList.push(obj)
                                    })
                                }
                            }
                        })
                    }
                }
            })
        }
        $scope.uploadFiles = function uploadFiles(files, errorFile) {
            if (!files.length || errorFile.length) {
                if (errorFile.length) {
                    logger.logError('上传失败,文件大小不得超过50M')
                }
                return
            }
            const formData = new FormData()
            for (let i = 0; i < files.length; i++) {
                formData.append('uploadFiles', files[i])
            }
            // 文件上传
            // loading动画
            const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest.post_uploadOtherInvoiceFile(formData).then((res) => {
                // 关闭loading
                layer.close(importinglayer)
                if (!res.data.success) {
                    return logger.logError(res.data.message || '上传失败')
                }
                logger.logSuccess('上传成功')
                $scope.reimburseFrom.otherFileList = $scope.reimburseFrom.otherFileList == null ? [] : $scope.reimburseFrom.otherFileList
                $scope.reimburseFrom.otherFileList = $scope.reimburseFrom.otherFileList.concat(res.data.value)
                // res.data.value.title = `本次共成功上传${res.data.value.sucessCount ? res.data.value.sucessCount : 0}张发票，${(res.data.value.receiveCount ? res.data.value.receiveCount : 0) - (res.data.value.sucessCount ? res.data.value.sucessCount : 0)}张失败`
            }, (response) => {
                if (response.status > 0) {
                    // 关闭loading
                    layer.close(importinglayer)
                    logger.logError('上传失败')
                }
            }, (evt) => {
                // file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total))
            })
        }
        $scope.fileDown = function (item) {
            window.open(`${host.etcloudIvatApp}expense/ivatExpense/downloadOtherInvoiceFileById?fileId=${item.storageKey}&accessToken=${localStorage.getItem('id_token')}`)
        }
        $scope.imgPreview = function (item) {
            $uibModal.open({
                templateUrl: 'previewImg.html',
                controller: ['$scope', '$uibModalInstance', 'hasPDFReader', function ctrl(scope, uibModalInstance, hasPDFReader) {
                    scope.imgSrc = `${host.etcloudIvatApp}common/common/getFile?fileKey=${item.storageKey}`
                    scope.fileType = item.fileType
                    if (hasPDFReader()) {
                        scope.canShowPDF = true
                    }
                    scope.cancel = function cancel() {
                        uibModalInstance.close()
                    }
                    scope.ok = function ok() {
                        uibModalInstance.close()
                    }
                }],
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail',
                backdrop: 'static',
            })
        }
        $scope.fielDel = function (item) {
            const fileId = item.storageKey
            httpRequest.get_deleteOtherInvoiceFileById({ fileId }).then((res) => {
                if (res.data.success) {
                    $scope.reimburseFrom.otherFileList = $scope.reimburseFrom.otherFileList.filter((x) => x.storageKey !== item.storageKey)
                    logger.logSuccess('文件删除成功')
                }
            })
        }
        $scope.delInvoice = function (ev, delItem) {
            ev.stopPropagation()
            sweetalert.confirm('删除提醒', '确认移除此单据？').then(() => {
                $scope.reimburseFrom.ivatExpenseBillRList = $scope.reimburseFrom.ivatExpenseBillRList.filter((x) => x.invoiceId !== delItem.invoiceId)
                let delListIndex = -1
                $scope.selectedFieldList.forEach((item, index) => {
                    if (item.confId == delItem.confId) {
                        delListIndex = index
                    }
                })
                if (delItem.expenseId) { // 删除已保存的单据
                    const isExist = $scope.removedInvoiceList.some((x) => {
                        x.invoiceId == delItem.invoiceId
                    })
                    if (!isExist) {
                        $scope.removedInvoiceList.push(delItem)
                    }
                }
                $scope.selectedFieldList[delListIndex].ivatExpenseBillRList = $scope.selectedFieldList[delListIndex].ivatExpenseBillRList.filter((x) => x.invoiceId !== delItem.invoiceId)
                logger.logSuccess('移除成功')
            }, () => {})
        }
        // 是否符合金钱，小数点前12位，后两位
        function isRuledMoney(argument) { // 企业信用度代码检测；
            const reg = /(^[1-9][0-9]{0,11}$)|(^[0]$)|(^[0]\.\d{0,2}$)|(^[1-9][0-9]{0,11}\.\d{0,2}$)/
            return reg.test(argument)
        }
        // 校验规则
        $scope.validateRules = {
            reimburseFromAmount: [{
                erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                condition(value) {
                    // 规则
                    return !isRuledMoney(value)
                },
            }],
        }
        $scope.allowDrop = function (ev) {
            ev.preventDefault()
        }

        $scope.drag = function (ev) {
            ev.dataTransfer.setData('Text', ev.target.id)
        }

        $scope.drop = function drop(ev) {
            ev.preventDefault()
            const dropConfId = ev.target.id
            const dragInvoice = JSON.parse(ev.dataTransfer.getData('Text'))
            if (dropConfId == dragInvoice.confId) {
                return
            }
            // 删除当前选择列表中的票据  添加到新的列表中
            $scope.reimburseFrom.ivatExpenseBillRList.forEach((x) => {
                if (x.invoiceId == dragInvoice.invoiceId) {
                    x.confId = dropConfId
                }
            })
            for (let i = 0; i < $scope.selectedFieldList.length; i++) {
                if ($scope.selectedFieldList[i].confId == dragInvoice.confId) {
                    $scope.selectedFieldList[i].ivatExpenseBillRList = $scope.selectedFieldList[i].ivatExpenseBillRList.filter((n) => n.invoiceId !== dragInvoice.invoiceId)
                }
            }
            for (let j = 0; j < $scope.selectedFieldList.length; j++) {
                if ($scope.selectedFieldList[j].confId == dropConfId) {
                    if (!$scope.selectedFieldList[j].ivatExpenseBillRList) {
                        $scope.selectedFieldList[j].ivatExpenseBillRList = []
                    }
                    dragInvoice.confId = dropConfId
                    $scope.selectedFieldList[j].ivatExpenseBillRList.push(dragInvoice)
                }
            }
            $scope.$apply()
        }
        $scope.showDetail = function (clickItem) {
            let currentList = []// 当前顺序的票面列表
            for (let j = 0, len = $scope.selectedFieldList.length; j < len; j++) {
                currentList = currentList.concat($scope.selectedFieldList[j].ivatExpenseBillRList ? $scope.selectedFieldList[j].ivatExpenseBillRList : [])
            }
            $uibModal.open({
                template: modalListTemplate,
                controller: 'modalListCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail collection-invoice-detail',
                resolve: {
                    items1() {
                        const data = {
                            modalListData: currentList,
                            currentInvoicId: clickItem.invoiceId,
                        }
                        return data
                    },
                },
            })
        }
    }
}
reimburseEditCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', '$stateParams', 'formvalidateApi', 'sweetalert']
export default reimburseEditCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/reimburseEditCtrl.js